var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6220_1537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C12.3135 21.0017 13.6143 20.7438 14.8278 20.2411C16.0413 19.7385 17.1435 19.001 18.071 18.071C19.001 17.1435 19.7385 16.0413 20.2411 14.8278C20.7438 13.6143 21.0017 12.3135 21 11C21.0017 9.68654 20.7438 8.38569 20.2411 7.17222C19.7385 5.95874 19.001 4.85656 18.071 3.92901C17.1435 2.99902 16.0413 2.26151 14.8278 1.75885C13.6143 1.25619 12.3135 0.998307 11 1.00001C9.68654 0.998334 8.38569 1.25623 7.17222 1.75889C5.95874 2.26154 4.85656 2.99904 3.92901 3.92901C2.99904 4.85656 2.26154 5.95874 1.75889 7.17222C1.25623 8.38569 0.998334 9.68654 1.00001 11C0.998307 12.3135 1.25619 13.6143 1.75885 14.8278C2.26151 16.0413 2.99902 17.1435 3.92901 18.071C4.85656 19.001 5.95874 19.7385 7.17222 20.2411C8.38569 20.7438 9.68654 21.0017 11 21Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L10 14L16 8.00002",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6220_1537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 -0.999985H23V23H-1V-0.999985Z",
    fill: "#1450EC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.4d8a7606e623db9ba8d2bf35011eaf75.svg";
export { ForwardRef as ReactComponent };